<template>
  <div :id="id" class="flex flex-col md:flex-row gap-6 p-8 bg-white rounded-xl">
    <div class="w-full md:w-1/2 flex flex-col gap-4">
      <div
        class="marked"
        :style="{ color: formData.textColor }"
        v-html="$marked(formData.text)"
      />
      <div v-if="formData.buttons?.length" class="flex flex-wrap gap-4">
        <template v-for="(button, index) in formData.buttons" :key="index">
          <BaseLink :href="button.url" target="_blank" class="hover:opacity-80">
            <BaseButton
              v-if="button.type === 'button'"
              :look="button.look"
              theme="none"
              :style="getButtonStyle(button)"
            >
              {{ button.text }}
            </BaseButton>
            <span v-else :style="{ color: button.color }">
              {{ button.text }}
            </span>
          </BaseLink>
        </template>
      </div>
    </div>
    <div class="w-full md:w-1/2">
      <div
        class="grid gap-6"
        :class="formData.images?.length > 1 && 'grid-cols-2'"
      >
        <template v-for="(url, index) in formData.images" :key="url + index">
          <div class="w-full">
            <img :src="url" class="w-full h-full rounded-xl" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentView',
  props: {
    id: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getButtonStyle(button) {
      if (button.look === 'border') {
        return {
          border: `2px solid ${button.color}`,
          color: button.color,
        }
      } else {
        return {
          'background-color': button.color,
          color: 'white',
        }
      }
    },
  },
}
</script>
